/**
 * Spaces API - Common enums
 *
 * Shared enums for the unified Spaces contract (GET /v1/spaces).
 */

import { z } from 'zod'

// A space is either a Section (any offering type) or a custom community group.
export const SpaceKindSchema = z.enum(['section', 'community'])
export type SpaceKind = z.infer<typeof SpaceKindSchema>

// Section offering-type, normalized for clients. Mirrors the backend
// `offering_type` values (ACADEMIC singular, ATHLETICS, ...) mapped to
// client-friendly kebab tokens.
export const SpaceSectionTypeSchema = z.enum([
  'academic',
  'athletic',
  'activity',
  'advisory',
  'community-group',
  'dorm'
])
export type SpaceSectionType = z.infer<typeof SpaceSectionTypeSchema>

// 3-state leader-settable visibility override. DEFAULT defers to the
// read-time auto-rule; SHOWN/HIDDEN are explicit overrides.
export const AppVisibilitySchema = z.enum(['DEFAULT', 'SHOWN', 'HIDDEN'])
export type AppVisibility = z.infer<typeof AppVisibilitySchema>
